<div class="overlay"></div>
<div class="modal">
    <div class="logo-container">
        <button class="close-btn" (click)="close()">✕</button>
    </div>

    <h3>Dataset: {{ dataset?.datasetName || dataset?.datasetCode || dataset?.id }}</h3>
    <div class="table-wrapper">
        <table>
            <thead>
                <tr>
                    <th>Field Key</th>
                    <th>Data Type</th>
                    <th>Description</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let item of data">
                    <td class="desc">{{ item?.fieldKey }}</td>
                    <td class="desc">{{ item?.dataType }}</td>
                    <td class="desc">{{ item?.description }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
